import { NotificationMessage } from '../../apis/notifications.api';
import dayjs from 'dayjs';
import styles from './notification-center.module.scss';

interface NotificationItemProps {
	notification: NotificationMessage;
	onClick?: (notification: NotificationMessage) => void;
}

export const NotificationItem = ({ notification, onClick }: NotificationItemProps) => {
	const handleClick = () => {
		onClick?.(notification);
	};

	return (
		<div
			role={onClick ? 'button' : undefined}
			tabIndex={onClick ? 0 : undefined}
			onClick={handleClick}
			className={`${styles.notificationItem} ${notification.read ? styles.read : styles.unread}`}>
			<span className={styles.notificationItemIcon} aria-hidden>
				!
			</span>
			<div className={styles.notificationItemContent}>
				<div className={styles.notificationItemMessage}>{notification.msg}</div>
				<div className={styles.notificationItemDate}>{dayjs(notification.date).format('DD-MM-YYYY HH:mm')}</div>
			</div>
		</div>
	);
};
